/// <reference path='../../interfaces/interfaces.d.ts' />

import Moment = moment.Moment;
import * as _ from 'lodash';

'use strict';

interface ITimePickerScope extends ng.IScope {
    activeElem: number;
    step: number;
    timeRange: Moment[];
    selectTime:  (time: Date) => void;
    ngModel: Date;
    ngModelMoment: Moment;
    master: Moment;
    disabled: boolean;
    openMenu: any;
    closeMenu: any;
}


class TimePickerDirective {

    public restrict;
    public require;
    public scope;
    public template;
    public replace;

    constructor(private $mdMenu: angular.material.IMenuService) {
        this.restrict = 'E';
        this.require = ['ngModel'];
        this.scope = {
            step: '@',
            ngModel: '=',
            ngModelMoment: '@?',
            master: '=',
            disabled: '=',
            label: '@?'
        };
        this.replace = true;
        this.template = `
            <md-input-container class='md-input-has-value w-100'>
                <label>{{label}}</label>
                <md-menu>
                    <md-button class='md-raised br-reset flex-center' ng-click="openMenu($event)" ng-disabled="disabled">
                        {{ ngModelMoment | moment: "HH:mm" }}
                        <md-icon md-font-library="material-icons" class='m--0 p--0 b-b-text'>unfold_more</md-icon>
                    </md-button>
                    <md-menu-content (width='4' ng-click='closeMenu($event)'>
                        <md-menu-item ng-repeat="time in timeRange track by $index" ng-click="selectTime(time)" 
                        ng-class="{'active': activeElem == $index}">
                            <md-button>
                                {{time | moment: "HH:mm"}}
                            </md-button>
                        </md-menu-item>
                    </md-menu-content>
                </md-menu>
            </md-input-container>
            `;
    }

    public controller = ($scope: ITimePickerScope, $mdMenu: angular.material.IMenuService) => {

        $scope.openMenu = function(ev: any): any {
            this.$mdMenu.open(ev);
        };

        $scope.closeMenu = function(ev: any): any {
            this.$mdMenu.close();
        };

        let MINUTES_START: number; // range start from MINUTES_START
        const MINUTES_END: number = ($scope.master && moment.isMoment($scope.master)) ? 1440 + 15 : 1440;

        let step: number = $scope.step || 15; // custom or default min step

        var dereg: any = $scope.$watch('master', () => {
            if ($scope.master && moment.isMoment($scope.master)) {
                MINUTES_START = $scope.master.diff(moment($scope.master).startOf('day'), 'minutes') + step;
                if ($scope.ngModel && $scope.master.diff($scope.ngModel, 'minutes') >= 0) {
                    $scope.ngModel = undefined;
                }
            } else {
                MINUTES_START = 0;
            }

            $scope.ngModelMoment = moment($scope.ngModel);

            if ($scope.ngModel && $scope.ngModelMoment && moment.isMoment($scope.ngModelMoment)) {
                this.setActiveElem($scope, MINUTES_START, step);
            } else {
                $scope.activeElem = -1;
            }

            $scope.ngModelMoment = this.setDefaultValue($scope.ngModelMoment, step);
            $scope.ngModel = $scope.ngModelMoment.toDate();
            $scope.timeRange = this.calcRange($scope.ngModelMoment, step, MINUTES_START, MINUTES_END);
        }, true);

        $scope.selectTime = (time: any) => {
            $scope.ngModelMoment = time;
            $scope.ngModel = time;
            this.setActiveElem($scope, MINUTES_START, step);
        };

        $scope.$on('$destroy', () => {
            dereg();
        });
    };

    private setDefaultValue(model: Moment, step: number): Moment {
        if (model && (model.minutes() % step) !== 0  && model.minutes() !== 59) {
            return model.minute(Math.floor(model.minutes() / step) * step);
        } else {
            return model;
        }
    }

    private calcRange(model: Moment, step: number, MINUTES_START: number, MINUTES_END: number): Moment[] {
        let timeRange: any[] = [];
        let startDate: Moment = (moment.isMoment(model)) ? angular.copy(model) : moment();

        _.range(MINUTES_START, MINUTES_END, step).forEach((i: number) => {
            timeRange.push(moment(startDate).startOf('day').add(i, 'm'));
        });
        return timeRange;
    }

    private setActiveElem(scope: ITimePickerScope, start: number, step: number): void {
        scope.activeElem = Math.floor((scope.ngModelMoment.diff(moment(scope.ngModelMoment).startOf('day'), 'minutes') - start) / step);
    }



    public static DirectiveFn(
        $mdMenu: angular.material.IMenuService
    ): TimePickerDirective {
        return new TimePickerDirective($mdMenu);
    }

}

TimePickerDirective.DirectiveFn.$inject = ['$mdMenu'];

angular.module('beneple.global')
    .directive('timepicker', TimePickerDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/timepicker.directive.ts